import React from "react";
import { Container, Content, TabBody } from "./HearingsTab";
import { EmptyState } from "../HearingBundles/steps/Step2pickpages";

const CaseDiscovery = () => {
  return (
    <Container>
      <Content>
        <TabBody>
          <EmptyState
            style={{
              fontSize: "18px",
              fontFamily: "openSans-SemiBold, sans-serif",
            }}
          >
            Coming Soon
          </EmptyState>
        </TabBody>
      </Content>
    </Container>
  );
};

export default CaseDiscovery;
